import Line from "./Line";
import { ComponentEx } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import * as React from "react";
import { connect } from "react-redux";
class ConnectorImpl extends ComponentEx {
    constructor(props) {
        super(props);
    }
    render() {
        const { source, target } = this.props;
        if (source === undefined || target === undefined) {
            return null;
        }
        const lineClass = target.id !== null ? "line-connect" : "line-disconnect";
        return (React.createElement("div", { className: "profile-connector-layer" },
            React.createElement(Line, { source: source.pos, target: target.pos, className: lineClass, curved: target.id !== null })));
    }
}
function mapStateToProps(state) {
    return {
        source: getSafe(state, ["session", "profileTransfer", "connection", "source"], undefined),
        target: getSafe(state, ["session", "profileTransfer", "connection", "target"], undefined),
    };
}
export default connect(mapStateToProps)(ConnectorImpl);
